"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = exports.RadioGroupContext = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Text_1 = require("../../foundations/Typography/Text");
exports.RadioGroupContext = react_1.default.createContext(undefined);
const RadioGroup = (props) => {
    const { children, disabled, error, label, value, onChange } = props;
    const [selectedValue, setSelectedValue] = react_1.default.useState(value || "");
    const labelNode = react_1.default.useMemo(() => {
        return typeof label === "string" ? react_1.default.createElement(Text_1.Text, null, label) : label;
    }, [label]);
    const onClickOption = react_1.default.useCallback((event) => {
        setSelectedValue(event.target.value);
        if (onChange) {
            onChange(event);
        }
    }, [onChange]);
    const contextValue = {
        selectedValue,
        onChange: onClickOption,
        disabled,
        error
    };
    return (react_1.default.createElement(exports.RadioGroupContext.Provider, { value: contextValue },
        react_1.default.createElement(foundations_1.Box, { sx: {
                display: "flex",
                flexDirection: "column",
                paddingX: "spacing-4"
            } },
            react_1.default.createElement(foundations_1.Box, { sx: {
                    fontSize: "font-size-4",
                    color: "text-default",
                    paddingY: "spacing-3",
                    fontWeight: "font-weight-medium",
                    lineHeight: "leading-2",
                    letterSpacing: "kerning-none"
                } }, labelNode),
            children)));
};
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map